import { Fragment, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SmarpayCloudPng from "../assets/landing/images/Smarpay-Cloud.png";
import { ShowImage } from "../shared/Images/ShowImage";

const DemoPage = () => {
  let [isFirstCollapsed, setisFirstCollapsed] = useState(false);
  let [is2Collapsed, setis2Collapsed] = useState(false);
  let [is3tCollapsed, setis3Collapsed] = useState(false);
  let [is4Collapsed, setis4Collapsed] = useState(false);
  let [is5Collapsed, setis5Collapsed] = useState(false);
  let [is6Collapsed, setis6Collapsed] = useState(false);
  let [is7Collapsed, setis7Collapsed] = useState(false);
  let [is8Collapsed, setis8Collapsed] = useState(false);
  let [is9Collapsed, setis9Collapsed] = useState(false);
  let [is10Collapsed, setis10Collapsed] = useState(false);
  let [is11Collapsed, setis11Collapsed] = useState(false);
  //// Template Highlights collapse
  let Firstcollapse = (a) => {
    if (a === "primary") {
      if (isFirstCollapsed === false) {
        setisFirstCollapsed(true);
      } else if (isFirstCollapsed === true) {
        setisFirstCollapsed(false);
      }
    } else if (a === "success") {
      if (is2Collapsed === false) {
        setis2Collapsed(true);
      } else if (is2Collapsed === true) {
        setis2Collapsed(false);
      }
    } else if (a === "info") {
      if (is3tCollapsed === false) {
        setis3Collapsed(true);
      } else if (is3tCollapsed === true) {
        setis3Collapsed(false);
      }
    } else if (a === "secondary") {
      if (is4Collapsed === false) {
        setis4Collapsed(true);
      } else if (is4Collapsed === true) {
        setis4Collapsed(false);
      }
    } else if (a === "warning") {
      if (is5Collapsed === false) {
        setis5Collapsed(true);
      } else if (is5Collapsed === true) {
        setis5Collapsed(false);
      }
    } else if (a === "danger") {
      if (is6Collapsed === false) {
        setis6Collapsed(true);
      } else if (is6Collapsed === true) {
        setis6Collapsed(false);
      }
    }
  };
  //FAQ'S
  let Secondcollpase = (a) => {
    if (a === "primary") {
      if (is7Collapsed === false) {
        setis7Collapsed(true);
      } else if (is7Collapsed === true) {
        setis7Collapsed(false);
      }
    } else if (a === "success") {
      if (is8Collapsed === false) {
        setis8Collapsed(true);
      } else if (is8Collapsed === true) {
        setis8Collapsed(false);
      }
    } else if (a === "secondary") {
      if (is9Collapsed === false) {
        setis9Collapsed(true);
      } else if (is9Collapsed === true) {
        setis9Collapsed(false);
      }
    } else if (a === "warning") {
      if (is10Collapsed === false) {
        setis10Collapsed(true);
      } else if (is10Collapsed === true) {
        setis10Collapsed(false);
      }
    } else if (a === "danger") {
      if (is11Collapsed === false) {
        setis11Collapsed(true);
      } else if (is11Collapsed === true) {
        setis11Collapsed(false);
      }
    }
  };
  const Sidebartoggled = () => {
    document.querySelector(".landing-page").classList.toggle("sidenav-toggled");
  };

  const pictureClass = "wd-90p mg-l-auto mg-r-auto rounded-10";
  const pictureClassMobile = "mg-t-120 rounded-10";

  var viewportWidth = document.documentElement.clientWidth;

  return (
    <Fragment>
      <ShowImage imgClass={viewportWidth < 480 ? pictureClassMobile : pictureClass}/>

      {/* <div className="landing-top-header overflow-hidden">

        <div className="demo-screen-headline main-demo main-demo-1 spacing-top overflow-hidden reveal" id="home">
          <Container className="px-sm-0">
            <Row>
              <Col xl={4} lg={4} className="animation-zidex pos-relative">
                <h4 className="fw-semibold mt-7">SMARPAY MOBILE PAYMENT HUB</h4>
                <h1 className="text-start fw-bold">Our Solutions Endless Possibilities!</h1>
                <h6 className="pb-3">WHERE DO WE OFFER OUR SERVICES?</h6>
                <ul>
                  
                <li><h2 className="text-start fw-bold">Vending</h2></li>
                <li><h2 className="text-start fw-bold">E-Charging</h2></li>
                <li><h2 className="text-start fw-bold">Laundry</h2></li>
                </ul>
                
                <h6 className="pb-3">YOUR SMARPAY AG</h6>

                <Link to="performance/dashboard"
                  className="btn ripple btn-min w-lg mb-3 me-2 btn-light"><i
                    className="fe fe-play me-2"></i> Get Started
                </Link>
                <Link to="payments/dashboard"
                  className="btn ripple btn-min w-lg btn-outline-light mb-3 me-2"><i
                    className="fe fe-eye me-2"></i> Discover More
                </Link>
              </Col>
              <Col xl={8} lg={8} className="my-auto">
                <img src={SmarpayCloudPng} alt="smarpay" />
              </Col>
            </Row>
          </Container>
        </div>
      </div> */}
    </Fragment>
  );
};
DemoPage.propTypes = {};

DemoPage.defaultProps = {};

export default DemoPage;
